import React from "react"
import {
	IconBulletListOutline18 as List,
	IconListCheckboxOutline18 as ListChecks,
	IconOrderedListOutline18 as ListOrdered,
} from "nucleo-ui-outline-18"

import { Tooltip } from "@productlane/ui"

import type { Editor } from "@tiptap/react"
import { EditorMenuDropdown } from "./editor-menu-dropdown"

interface ListDropdownProps {
	editor: Editor
	containerRef?: React.RefObject<HTMLDivElement | null>
}

export const EditorMenuListDropdown: React.FC<ListDropdownProps> = ({
	editor,
	containerRef,
}) => {
	const listTypes = [
		{ id: "bulletList", label: "List", icon: List },
		{ id: "orderedList", label: "Numbered List", icon: ListOrdered },
		{ id: "taskList", label: "Checklist", icon: ListChecks },
	]

	const onSelect = (id: string | number) => {
		const listType = id as string

		const listItemTypeMap: Record<string, string> = {
			bulletList: "listItem",
			orderedList: "listItem",
			taskList: "taskItem",
		}

		const itemType = listItemTypeMap[listType]
		if (itemType) {
			editor
				.chain()
				.focus(undefined, { scrollIntoView: false })
				.toggleList(listType, itemType)
				.run()
		}
	}

	const activeListItem = listTypes.find(({ id }) => editor.isActive(id))

	return (
		<Tooltip
			shouldWrapChildren
			label={activeListItem?.label || listTypes[0]?.label}
		>
			<EditorMenuDropdown
				containerRef={containerRef}
				items={listTypes}
				activeItem={activeListItem?.id}
				onSelect={onSelect}
				triggerIcon={activeListItem?.icon ?? List}
			/>
		</Tooltip>
	)
}
